<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M19.5 5A1.5 1.5 0 0018 6.5V18H6.5a1.5 1.5 0 000 3H19a2 2 0 002-2V6.5A1.5 1.5 0 0019.5 5zM45 21h12.5a1.5 1.5 0 000-3H46V6.5a1.5 1.5 0 00-3 0V19a2 2 0 002 2zM19 43H6.5a1.5 1.5 0 000 3H18v11.5a1.5 1.5 0 003 0V45a2 2 0 00-2-2zM57.5 43H45a2 2 0 00-2 2v12.5a1.5 1.5 0 003 0V46h11.5a1.5 1.5 0 000-3zM37.5 24.5h-11a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-11a2 2 0 00-2-2zm-1 12h-9v-9h9z"/></svg>